import React, { useEffect } from "react";

import CONSTANT from "../../constants/Constant";

import Footer from "../shared/layout/Footer";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";
import SignIn from "./SignIn";
import leftIcon from "../../assets/img/signin/leftIcon.svg";
import doctorIcon from "../../assets/img/signin/doctor-icon.svg";
import topRoundIcon from "../../assets/img/signin/topRound.svg";
import bottomRoundIcon from "../../assets/img/signin/bottomRound.svg";
// import {redirectTo} from "../shared/chatbotNew/ChatServices";
import routes from "../../constants/Routes";
import SignInSignUpHeaderWrapper from "../shared/layout/HeadWrappers/SignInSignUpHeaderWrapper";
import { useHistory, useLocation } from "react-router-dom";
import GLOBAL from "../../global";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const SignInWrapper = () => {
    const history = useHistory();
    const location = useLocation();
    const { isSpinealignEnabled } = useTenantFeatures();

    useEffect(() => {
        // If feature is enabled and user is on root path (/), redirect to snclogin
        // Exception: allow /sign-in for testing purposes
        if (isSpinealignEnabled && location.pathname === '/') {
            history.push(routes.sncLogin);
        }
    }, [isSpinealignEnabled, location.pathname, history]);

    return (
        <>
            {/*<MobileHeader/>*/}
            <SignInSignUpHeaderWrapper />

            <BodyWithTopMenu styleClass="justify-content-center" pageName={CONSTANT.PAGE_NAME.MY_CALENDAR}>
                {/*<div className="d-flex align-items-center">*/}
                <SignIn
                    // imgComponent={
                    //     <div>
                    //         <img src={leftIcon} className='left_icon' alt="img" />
                    //         <img src={doctorIcon} className='doctorimg' alt="img" />
                    //         <img src={topRoundIcon} className='halfround' alt="img" />
                    //         <img src={bottomRoundIcon} className='roundBottom' alt="img" />
                    //     </div>
                    // }
                    // logoComponent={
                    //     <div className="color_logo_mmh">
                    //         {GLOBAL.LOGO_URL ? (
                    //             <img src={GLOBAL.LOGO_URL} alt="MMH Logo" />) : (
                    //             <img src={mmhColorLogo} alt="MMH Logo" />)}
                    //     </div>
                    // }
                    onClickRedirectToSignUp={() => {
                        const hash = window.location.hash;
                        const queryString = hash.includes('?') ? hash.split('?')[1] : '';
                        history.push(`${routes.signUp}${queryString ? '?' + queryString : ''}`);
                    }}
                />
                {/*</div>*/}

            </BodyWithTopMenu>
            <Footer />
        </>
    );
}

export default SignInWrapper;
